import { useState } from 'react'
import { Time, Validate } from '../utils'
import useInterval from './useInterval'

const DEFAULT_DELAY = 1000
function getDelayFromExpiryTimestamp(expiryTimestamp) {
  if (!Validate.expiryTimestamp(expiryTimestamp)) {
    return null
  }
  // @ts-ignore
  const seconds = Time.getSecondsFromExpiry(expiryTimestamp)
  const extraMilliSeconds = Math.floor((seconds - Math.floor(seconds)) * 1000)
  return extraMilliSeconds > 0 ? extraMilliSeconds : DEFAULT_DELAY
}

export default function useTimer({ expiryTimestamp: expiry, onExpire, autoStart = true }) {
  const [expiryTimestamp, setExpiryTimestamp] = useState(expiry)
  // @ts-ignore
  const [seconds, setSeconds] = useState(Time.getSecondsFromExpiry(expiryTimestamp))
  const [isRunning, setIsRunning] = useState(autoStart)
  const [didStart, setDidStart] = useState(autoStart)
  const [delay, setDelay] = useState(getDelayFromExpiryTimestamp(expiryTimestamp))

  function handleExpire() {
    Validate.onExpire(onExpire) && onExpire()
    setIsRunning(false)
    setDelay(null)
  }

  function pause() {
    setIsRunning(false)
  }

  function restart(newExpiryTimestamp, newAutoStart = true) {
    setDelay(getDelayFromExpiryTimestamp(newExpiryTimestamp))
    setDidStart(newAutoStart)
    setIsRunning(newAutoStart)
    setExpiryTimestamp(newExpiryTimestamp)
    // @ts-ignore
    setSeconds(Time.getSecondsFromExpiry(newExpiryTimestamp))
  }

  function resume() {
    const time = new Date()
    time.setMilliseconds(time.getMilliseconds() + seconds * 1000)
    restart(time)
  }

  function start() {
    if (didStart) {
      // @ts-ignore
      setSeconds(Time.getSecondsFromExpiry(expiryTimestamp))
      setIsRunning(true)
    } else {
      resume()
    }
  }

  useInterval(
    () => {
      if (delay !== DEFAULT_DELAY) {
        setDelay(DEFAULT_DELAY)
      }
      // @ts-ignore
      const secondsValue = Time.getSecondsFromExpiry(expiryTimestamp)
      setSeconds(secondsValue)
      if (secondsValue <= 0) {
        handleExpire()
      }
    },
    isRunning ? delay : null
  )

  return {
    ...Time.getTimeFromSeconds(seconds),
    start,
    pause,
    resume,
    restart,
    isRunning,
  }
}
